module.exports = __webpack_public_path__ + "img/caseclub-logo-short.b19b370c.svg";